export default {
  UI_AVATARS_ENDPOINT: 'https://ui-avatars.com/api/',
  CACOFONIX_WSS: process.env.REACT_APP_CACOFONIX_WSS,
  SIP_DOMAIN: process.env.REACT_APP_SIP_DOMAIN,
  JUDITE_API_ENDPOINT: process.env.REACT_APP_JUDITE_API_ENDPOINT,
  SALESFORCE_URL: process.env.REACT_APP_SALESFORCE_URL,
  JUDITE_URL: process.env.REACT_APP_JUDITE_URL,
  SECONDS_IN_MILLISECONDS: 1000,
  CACOFONIX_PING_INTERVAL: 15, 
  JUDITE_INTERVAL_OFFSET: 5
}
